import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2daca54f")

_pushScopeId("data-v-2daca54f")
const _hoisted_1 = { class: "FTLOrderBasicDelivery" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "FTLOrderBasicDelivery__title" }, "Информация о доставке", -1)
const _hoisted_3 = { class: "FTLOrderBasicDelivery__body" }
const _hoisted_4 = { class: "body__block" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Статус доставки", -1)
const _hoisted_6 = { class: "block__text" }
const _hoisted_7 = { class: "body__block" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Дата и время забора", -1)
const _hoisted_9 = { class: "block__text" }
const _hoisted_10 = { class: "block__text" }
const _hoisted_11 = { class: "body__block" }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Количество пунктов", -1)
const _hoisted_13 = { class: "block__text" }
const _hoisted_14 = { class: "body__block" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Общая сумма к оплате", -1)
const _hoisted_16 = { class: "block__text" }
const _hoisted_17 = {
  key: 0,
  class: "body__block"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Номер АВР", -1)
const _hoisted_19 = { class: "block__text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ftl_order_status = _resolveComponent("ftl-order-status")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("p", _hoisted_6, [
          _createVNode(_component_ftl_order_status, {
            "status-code": _ctx.FTLOrderState.data.status_code,
            "status-text": _ctx.FTLOrderState.data.status
          }, null, 8, ["status-code", "status-text"])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("p", _hoisted_9, _toDisplayString(_ctx.FTLOrderState.data.take_date), 1),
        _createVNode("p", _hoisted_10, _toDisplayString(_ctx.FTLOrderState.data.take_time), 1)
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("p", _hoisted_13, _toDisplayString(_ctx.FTLOrderState.data.pointsSum) + " " + _toDisplayString(_ctx.declOfNum(_ctx.FTLOrderState.data.pointsSum, _ctx.POINTS_TOKENS)), 1)
      ]),
      _createVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode("p", _hoisted_16, _toDisplayString(_ctx.FTLOrderState.data.paid_price_total + ' ₸' || 'Не указана'), 1)
      ]),
      (_ctx.FTLOrderState.data.act_number)
        ? (_openBlock(), _createBlock("div", _hoisted_17, [
            _hoisted_18,
            _createVNode("p", _hoisted_19, _toDisplayString(_ctx.FTLOrderState.data.act_number || 'Не указан'), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})